import clsx from "clsx";
import { useRef, useState } from "react";
import {Link} from "@inertiajs/react";
export default function () {
  return <SeoText head={head} tail={tail} />;
}

function SeoText({ head, tail }) {
  const refVisible = useRef(null);
  const refHidden = useRef(null);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="container mx-auto">
      <div className="prose max-w-none">
        <div className="px-8 xl:px-0">
          <div className="relative" onClick={() => setCollapsed(!collapsed)}>
            <div
              className={clsx(
                !collapsed && "hidden",
                collapsed &&
                  "flex justify-center items-end inset-x-0 absolute bottom-0 h-64 content-[''] bg-gradient-to-b from-transparent to-white"
              )}
            >
              <button
                className="border-2 bg-white  border-black hover:bg-black hover:text-white rounded-full px-8 py-4 my-8 flex items-center"
                onClick={() => setCollapsed(!collapsed)}
              >
                Показать все
              </button>
            </div>

            {head}
          </div>

          <div
            className={clsx(collapsed && "hidden", "relative")}
            onClick={() => setCollapsed(!collapsed)}
            ref={refHidden}
          >
            {tail}

            <div className={clsx("flex justify-center w-full")}>
              <button
                className="border-2 bg-white  border-black hover:bg-black hover:text-white rounded-full px-8 py-4 my-8 flex items-center"
                onClick={() => setCollapsed(!collapsed)}
              >
                Скрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const head = (
  <>
    <h1>Купить воздушные шары в Красноярске с доставкой — Красный шар</h1>
    <p>
      Ищете, где <strong>купить воздушные шары в Красноярске</strong> для яркого
      и незабываемого праздника? <strong>Магазин воздушных шаров</strong>{" "}
      «Красный шар» — ваш надежный партнер в мире праздничного декора! У нас вы
      найдете огромный выбор воздушных шаров для любого события: от оформление
      шарами до грандиозного корпоративного оформления шарами.
    </p>

    <h2>
      Шары на день рождения в Красноярске — волшебство для каждого возраста
    </h2>
    <p>
      Сделайте день рождения по-настоящему ярким! Мы предлагаем все, что нужно
      для идеального праздника:
    </p>
    <ul>
      <li>
        • Классика и оригинальность:{" "}
        <Link href="/t/categories/roznichnyi-sait/shary-na-dien-rozhdienia">
          Гелиевые шары на день рождения
        </Link>
        ,
        <Link href="/t/categories/roznichnyi-sait/folghirovannyie-shary-s-risunkom">
          фольгированные шары с рисунком и надписями
        </Link>
        , а также стильные{" "}
        <Link href="/t/categories/roznichnyi-sait/shary-na-dien-rozhdienia">
          букеты и композиции из шаров
        </Link>
        .
      </li>
      <li>
        • Акцент на дате: Эффектные{" "}
        <Link href="/t/categories/roznichnyi-sait/folghirovannyie-tsifry">
          шары с цифрами
        </Link>{" "}
        на любой возраст — от цифры 1 из шаров для малыша до больших цифр из
        шаров для юбилея. Создадим объемные двухзначные цифры из шаров.
      </li>
      <li>
        • Для особых случаев:{" "}
        <Link href="/t/categories/roznichnyi-sait/shary-na-dien-rozhdienia">
          Именные шары на день рождения
        </Link>
        , шары в комплекте, готовые подарочные наборы с шарами.
      </li>
      <li>
        • Полный декор: Оформление дня рождения шарами любой сложности — арки и
        гирлянды из шаров, тематические фотозоны из шаров, которые станут
        центром праздника.
      </li>
      <li>
        • Удобство и выгода: Доставка шаров на день рождения по Красноярску в
        удобное время. У нас вы можете заказать шары на день рождения недорого,
        а также воспользоваться выгодными акциями на шары.
      </li>
    </ul>

    <p>
      Заказать шары на день рождения в Красноярск с нашей доставкой — значит
      получить качество, яркие эмоции и идеальный сервис!
    </p>
  </>
);

const tail = (
  <>
    <h2>Трогательное оформление выписки шарами в Красноярске</h2>
    <p>
      Поздравьте с самым важным событием — рождением малыша! Мы поможем создать
      трогательную и радостную атмосферу:
    </p>
    <ul>
      <li>
        • Тематические наборы:{" "}
        <Link href="/t/categories/roznichnyi-sait/vypiska">
          Шары на выписку мальчика или девочки
        </Link>{" "}
        в голубых или розовых тонах, а также универсальные нейтральные
        композиции.
      </li>
      <li>
        • Персонализация:{" "}
        <Link href="/t/categories/roznichnyi-sait/vypiska">
          Шары с именем на выписку
        </Link>
        , фольгированные шары с поздравлениями для молодых родителей.
      </li>
      <li>
        • Красивые формы:{" "}
        <Link href="/t/categories/roznichnyi-sait/vypiska">
          Композиции и букеты из шаров на выписку
        </Link>
      </li>
    </ul>
    <p>
      Значимые детали:{" "}
      <Link href="/t/categories/roznichnyi-sait/vypiska">
        Шары цифра (метрика) на выписку
      </Link>{" "}
      с весом или возрастом малыша, шары с гелием, парящие под потолком.
    </p>

    <p>
      <Link href="/t/categories/roznichnyi-sait/vypiska">
        Купить шары на выписку в Красноярске
      </Link>{" "}
      — значит доверить важный момент профессионалам!
    </p>

    <h2>Тематические шары и оформление праздников в Красноярске</h2>
    <p>
      Хотите устроить незабываемую вечеринку? Мы создаем магию любой тематики!
    </p>

    <ul>
      <li>
        • Любимые герои: Шары в стиле единорогов, с супергероями, принцессами
        или Три кота и другие воздушные шарики.{" "}
      </li>
      <li>
        • Сезон и праздники: Новогодние тематические шары, оформление Хэллоуина,
        Дня святого Валентина, 8 марта и 23 февраля.
      </li>
      <li>
        • Для бизнеса: Корпоративное оформление шарами, оформление открытия
        магазина, шары с логотипом компании.
      </li>
      <li>
        • Масштабные проекты: Полное оформление тематических праздников шарами —
        от декора фотозон до сложных инсталляций и фигур.
      </li>
    </ul>

    <h2>Ходячие и картонные ростовые фигуры</h2>
    <p>Сделайте праздник интерактивным и фото-дружелюбным!</p>
    <ul>
      <li>
        • Ожившие герои: Ходячие фигуры — медведь, заяц, единорог, супергерои,
        клоуны. Идеально для детских праздников, корпоративов и рекламных акций.
      </li>
      <li>
        • Креативный декор: Картонные ростовые фигуры для фотозон, выставок и
        мероприятий. Изготовим ростовую фигуру из картона на заказ по вашему
        дизайну или фото.
      </li>
    </ul>

    <h2>Праздничные товары и оригинальные подарки</h2>
    <p>«Красный шар» — это не только шары, но и тысячи идей для праздника:</p>
    <ul>
      <li>
        • WOW-эмоции: Подарочные WOW коробки (вау боксы) с сюрпризом внутри —
        для мужчин, женщин, на юбилей или свадьбу.
      </li>
      <li>
        • Всё для праздника: Большой раздел праздничных товаров — от хлопушек и
        конфетти до подарочной упаковки и тематического декора.
      </li>
    </ul>

    <h2>Почему выбирают магазин шаров «Красный шар»?</h2>
    <ul>
      <li>
        • Огромный ассортимент: Все виды шаров (латексные, фольгированные,
        гелевые, цифры, фигуры).
      </li>
      <li>
        • Собственное производство: Изготовление сложного декора, фигур и
        оформления под ключ.
      </li>
      <li>
        • Быстрая доставка: Доставка шаров по Красноярску ежедневно, возможен
        срочный заказ.
      </li>
      <li>
        • Профессиональные консультанты: Помогут выбрать идеальное решение для
        вашего бюджета и события.
      </li>
      <li>
        • Доступные цены: Шары на день рождения цена и шары на выписку стоимость
        приятно удивят. Работаем на рынке праздничного декора много лет.
      </li>
      <li>
        • Хотите купить шары с гелием на день рождения в Красноярске, заказать
        оформление выписки или устроить тематическую вечеринку? Звоните в
        магазин воздушных шаров «Красный шар»! Мы превратим любое событие в
        красочный и радостный праздник!
      </li>
    </ul>

    <p>Красный шар — дарим эмоции с каждым шариком!</p>
  </>
);

const text = <></>;
